import createEventCampaignSaga from './createEventCampaignSaga'
import createWishCampaignSaga from './createWishCampaignSaga'
import createEventStep from './createEventStepSaga'
import createWishStep from './createWishStepSaga'
import editCampaignSaga from './editCampaignSaga'
import editStepSaga from './editStepSaga'
import eventCampaignListSaga from './eventCampaignListSaga'
import wishCampaignListSaga from './wishCampaignListSaga'
import oneCampaignSaga from './oneCampaignSaga'
import runCampaignSaga from './runCampaignSaga'
import resumeCampaignSaga from './resumeCampaignSaga'
import pauseCampaignSaga from './pauseCampaignSaga'
import runCampaignStepSaga from './runCampaignStepSaga'
import deleteCampaignSaga from './deleteCampaignSaga'
import deleteCampaignStepSaga from './deleteCampaignStepSaga'

const campaignsSagas = [
    createEventCampaignSaga(),
    createWishCampaignSaga(),
    createEventStep(),
    createWishStep(),
    editCampaignSaga(),
    editStepSaga(),
    eventCampaignListSaga(),
    wishCampaignListSaga(),
    oneCampaignSaga(),
    runCampaignSaga(),
    runCampaignStepSaga(),
    resumeCampaignSaga(),
    pauseCampaignSaga(),
    deleteCampaignSaga(),
    deleteCampaignStepSaga()
]

export default campaignsSagas
